var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mach-doch-einfach-page"},[_vm._v(" denemeler ")])
}
var staticRenderFns = []

export { render, staticRenderFns }